import { useEffect, useRef, useState } from 'react';
import api from '../../services/api';
import { fmtDisp } from '../../utils/helpers';

function SearchBar({ portalName, resetKey }) {
  const [q, setQ] = useState('');
  const [results, setResults] = useState(null);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const timer = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  useEffect(() => {
    setQ('');
    setResults(null);
    setOpen(false);
  }, [resetKey]);

  const doSearch = (term) => {
    setQ(term);
    if (term.length < 2) {
      setResults(null);
      setOpen(false);
      return;
    }
    clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      try {
        const data = await api.globalSearch(term);
        setResults(data || { users: [], announcements: [], events: [] });
        setOpen(true);
      } catch (e) {
        setResults({ users: [], announcements: [], events: [] });
        setOpen(true);
      }
    }, 300);
  };

  const total = results
    ? (results.users?.length || 0) + (results.announcements?.length || 0) + (results.events?.length || 0)
    : 0;

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <div style={{ display: 'flex', alignItems: 'center', background: '#f1f5f9', borderRadius: 8, padding: '0 10px', border: open ? '1.5px solid #6366f1' : '1.5px solid transparent', transition: 'border 0.2s' }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>
        <input
          value={q}
          onChange={e => doSearch(e.target.value)}
          onFocus={() => q.length >= 2 && results && setOpen(true)}
          placeholder={`Search ${portalName || 'anything'}...`}
          autoComplete="off"
          name="global-search"
          style={{ border: 'none', background: 'transparent', padding: '7px 8px', fontSize: 12, outline: 'none', width: 180, fontFamily: 'inherit' }}
        />
        {q && <span onClick={() => { setQ(''); setResults(null); setOpen(false); }} style={{ cursor: 'pointer', color: '#94a3b8', fontSize: 14 }}>x</span>}
      </div>

      {open && results && (
        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, minWidth: 300, background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10, boxShadow: '0 8px 24px rgba(0,0,0,0.12)', zIndex: 1000, marginTop: 4, maxHeight: 360, overflow: 'auto' }}>
          {total === 0 ? (
            <div style={{ padding: 20, textAlign: 'center', color: '#94a3b8', fontSize: 12 }}>No results for "{q}"</div>
          ) : (
            <>
              {results.users?.length > 0 && (
                <div>
                  <div style={{ padding: '8px 12px', fontSize: 10, fontWeight: 700, color: '#6366f1', textTransform: 'uppercase', background: '#f8fafc' }}>People ({results.users.length})</div>
                  {results.users.map((u) => (
                    <div key={u.id} style={{ padding: '8px 12px', display: 'flex', alignItems: 'center', gap: 10, borderBottom: '1px solid #f8fafc' }}>
                      <div style={{ width: 28, height: 28, borderRadius: '50%', background: '#6366f1', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 700 }}>
                        {(u.name || '?').substring(0, 2).toUpperCase()}
                      </div>
                      <div>
                        <div style={{ fontSize: 12, fontWeight: 600 }}>{u.name}</div>
                        <div style={{ fontSize: 10, color: '#94a3b8' }}>{u.emp_id} Â· {u.role}</div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {results.announcements?.length > 0 && (
                <div>
                  <div style={{ padding: '8px 12px', fontSize: 10, fontWeight: 700, color: '#f59e0b', textTransform: 'uppercase', background: '#f8fafc' }}>Announcements ({results.announcements.length})</div>
                  {results.announcements.map((a, i) => (
                    <div key={i} style={{ padding: '8px 12px', fontSize: 12, borderBottom: '1px solid #f8fafc' }}>
                      <div style={{ fontWeight: 600 }}>{a.title}</div>
                      <div style={{ fontSize: 10, color: '#94a3b8', marginTop: 2 }}>{(a.body || '').substring(0, 80)}...</div>
                    </div>
                  ))}
                </div>
              )}
              {results.events?.length > 0 && (
                <div>
                  <div style={{ padding: '8px 12px', fontSize: 10, fontWeight: 700, color: '#3b82f6', textTransform: 'uppercase', background: '#f8fafc' }}>Events ({results.events.length})</div>
                  {results.events.map((ev, i) => (
                    <div key={i} style={{ padding: '8px 12px', fontSize: 12, borderBottom: '1px solid #f8fafc' }}>
                      <div style={{ fontWeight: 600 }}>{ev.title}</div>
                      <div style={{ fontSize: 10, color: '#94a3b8' }}>{fmtDisp(ev.date)}</div>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default SearchBar;

